import first from 'lodash/first';
import values from 'lodash/values';
import { createSelector } from 'reselect';
import { Events } from '../../../../../types/index';
import {
    eventsCardInfoLookup,
    getSearchContent,
    getSearchSection,
} from '../../../../../utils/general';
import { hasEventResults as hasEventResultsShared } from '../../../utils/events';

const _getMaxPage = ({ events }: { events: Events }) => {
    if (typeof events === 'undefined') return 0;
    const firstKey = parseInt(first(Object.keys(events)) || '0');
    let pageCount;

    if (events[firstKey]) {
        pageCount = events[firstKey].pageCount;
    }

    return pageCount;
};

const getSuggestedRawEvents = (state: any) => state.suggestions.rawEvents;
const getEntities = (state: any) => state.content.entities;
const getPagination = (state: any) => state.pagination;
const getCurrencyFormat = (state: any) => state.currencyFormat;
const getIsOnline = (state: any) => state.location.isOnline;

const getSearchSectionSelector = createSelector([getIsOnline], (isOnline) =>
    getSearchSection(isOnline),
);

const getEventResults: any = createSelector(
    [getEntities, getPagination, getCurrencyFormat, getSearchSectionSelector],
    (entities, pagination, currencyFormat, section) =>
        getSearchContent(entities, pagination, currencyFormat, section),
);

export const hasEventResults = createSelector(
    [getEventResults],
    (results: any) => hasEventResultsShared(results),
);

export const isNextDisabled = createSelector([getPagination], (pagination) => {
    const pageCount = _getMaxPage(pagination) || 0;
    const { currentPage } = pagination;

    return currentPage === pageCount - 1;
});

export const getEventSuggestions: any = createSelector(
    [getSuggestedRawEvents, getCurrencyFormat, getSearchSectionSelector],
    (rawEvents, currencyFormat, section) => {
        const events = values(rawEvents);

        return eventsCardInfoLookup({
            bucketsContent: events,
            currencyFormat,
            section,
        });
    },
);
